import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c402560c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c402560c')) {
      api.createRecord('c402560c', component.options)
    } else {
      api.reload('c402560c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=c402560c&", function () {
      api.rerender('c402560c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R9Yl4BeyUCTb/JS/comp/ErrorMessage.vue"
export default component.exports